import { backgroundColor, blackColors, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const dashboardStyle = (theme) => ({
	servicesContainer: {},
	servicesItem: {
		'& > div': {
			// card
			margin: '8px 0',
			height: 'calc(100% - 16px)',
			[theme.breakpoints.down('xs')]: {
				margin: '4px 0',
				height: 'calc(100% - 8px)',
			},
			'& > div': {
				// card body
				padding: '16px',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				'& div': {
					'&:last-of-type': {
						'& p': {
							textAlign: 'right',
							'&:first-of-type': {
								marginBottom: '6px',
								lineHeight: theme.direction === 'rtl' ? 1.25 : 'normal',
							},
							'&:last-of-type': {
								marginBottom: 0,
								fontWeight: 'bold',
								lineHeight: theme.direction === 'rtl' ? 1.25 : 'normal',
							},
						},
					},
				},
			},
		},
	},
	servicesItemIcon: {
		width: 40,
		height: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 8,
		'& svg': {
			fill: 'white !important',
		},
	},
	chartWrapper: {
		// card
		marginBottom: '6px',
		marginTop: 0,
		'& > div': {
			// card body
			padding: '24px 24px 24px 16px',
			[theme.breakpoints.down('sm')]: {
				padding: '16px',
			},
		},
	},
	chartHeader: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'column',
		marginBottom: '38px',
		[theme.breakpoints.up('sm')]: {
			flexDirection: 'row',
		},
		'& > div': {
			'&:first-of-type': {
				[theme.breakpoints.up('xs')]: {
					width: '240px',
				},
				[theme.breakpoints.up('sm')]: {
					width: '248px',
				},
				[theme.breakpoints.up('md')]: {
					width: '252px',
				},
				[theme.breakpoints.up('lg')]: {
					width: '288px',
				},
				'& > div': {
					marginTop: 0,
				},
			},
		},
	},
	chartLegend: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginBottom: '16px',
		[theme.breakpoints.down('sm')]: {
			marginBottom: '10px',
		},
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
		},
		'& > div': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			marginRight: '70px',
			[theme.breakpoints.down('xs')]: {
				marginRight: 0,
				marginBottom: '5px',
			},
			'& > div': {
				height: '4px',
				width: '4px',
				backgroundColor: primaryColor[0],
				border: 'none',
				marginRight: '8px',
			},
		},
	},
	chartFooter: {
		borderTop: 'solid 2px #eaeaea',
		paddingTop: '40px',
		display: 'flex',
		justifyContent: 'flex-end',
		[theme.breakpoints.down('sm')]: {
			paddingTop: '10px',
		},
	},
	chartBody: {
		padding: '0 57px',
		position: 'relative',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
		'& .ct-chart > svg': {
			overflow: 'visible',
		},
		'& .ct-series-a .ct-bar': {
			stroke: primaryColor[0],
			// strokeWidth: '30px',
			// [theme.breakpoints.down('sm')]: {
			// 	strokeWidth: '25px',
			// },
			// [theme.breakpoints.down('xs')]: {
			// 	strokeWidth: '20px',
			// },
		},
		'& .ct-label': {
			fontSize: theme.fontSize(14),
			lineHeight: theme.fontSize(18),
			fontFamily: theme.fontFamily.albert.regular,
			letterSpacing: '0.16px',
			'&.ct-vertical': {
				color: blackColors[3],
				transform: 'translateY(9px)',
				whiteSpace: 'nowrap',
			},
			'&.ct-horizontal': {
				fontFamily: theme.fontFamily.albert.bold,
				color: blackColors[1],
			},
		},
	},
	chartBodyLoading: {
		height: 300,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	chartWrapperHeader: {
		marginBottom: 8,
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
			textAlign: 'left',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 56,
		width: 56,
		marginRight: 8,
	},
	billItem: {
		'& > div': {
			// card
			[theme.breakpoints.down('xs')]: {
				marginBottom: '2px',
				marginTop: '2px',
			},
			'& > div': {
				// card body
				display: 'flex',
				justifyContent: 'space-between',
				padding: '8px 24px 4px',
				'& > div': {
					'&:first-of-type': {
						display: 'flex',
						alignItems: 'flex-end',
						justifyContent: 'flex-start',
						marginBottom: '3px',
						'& > div': {
							display: 'flex',
							alignItems: 'center',
							'& p': {
								marginBottom: 0,
							},
						},
					},
					'&:last-of-type': {
						'& > p': {
							marginBottom: '14px',
							textAlign: 'right',
						},
						'& > div': {
							display: 'flex',
							justifyContent: 'flex-end',
							alignItems: 'center',
							'& p': {
								marginBottom: 0,
								fontWeight: 'bold',
								'&:first-of-type': {
									marginRight: '4px',
								},
							},
						},
					},
				},
			},
		},
	},
	billItemSmallIcon: {
		width: '12px',
		height: '12px',
		marginBottom: '3px',
	},
	success: {
		color: '#00dad5',
	},
	warning: {
		color: '#d41565',
	},
	usageWrapper: {
		marginTop: '19px',
	},
	selectContainer: {
		height: '100%',
		'& > div > div': {
			// alternative select
			marginBottom: 24,
			[theme.breakpoints.up('lg')]: {
				height: 'calc(100% - 40px)',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-end',
			},
		},
	},
	tooltip: {
		fontFamily: theme.fontFamily.albert.regular,
		fontSize: '12px',
		fontWeight: 'normal',
		padding: '8px 16px',
	},
	noDataAvailable: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%,-50%)',
		'& p': {
			marginBottom: 0,
			textAlign: 'center',
		},
	},
	axisYDescription: {
		textAlign: 'right',
		marginTop: '-15px',
		marginBottom: '20px',
	},
	headerProgress: {
		marginTop: '15px',
		marginLeft: '15px',
	},
	bannerContainer: {
		display: 'flex',
		width: '100%',
		flexWrap: 'wrap',
	},
	bannerItem: {
		flex: '1 0 33%',
		[theme.breakpoints.down('md')]: {
			flex: '1 0 100%',
		},
	},
	loadingWrapper: {
		position: 'fixed',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		zIndex: 999999,
		background: backgroundColor[0],
	},
});

export default dashboardStyle;
